export default {
  SET: (state, payload) => {
    if (Array.isArray(payload)) {
      payload.map(obj => {
        state[obj.key] = obj.value;
      });
    } else {
      state[payload.key] = payload.value;
    }
  },

  RESET: state => {
    Object.entries(state.form_header).map((val) => {
      if(val[0] !== 'tnosal' && val[0] !== 'telectro') {
        switch (typeof val[1]) {
          case 'number':
            state.form_header[val[0]] = 0
            break;
          case 'string':
            state.form_header[val[0]] = ''
            break;
        }
      }
    });
    
    Object.entries(state.form_special_request).map((val) => {
      switch (typeof val[1]) {
        case 'number':
          state.form_special_request[val[0]] = 0
          break;
        case 'string':
          state.form_special_request[val[0]] = ''
          break;
      }
    });
    
    state.form_contact = []
    state.form_typology = []
    state.form_card = []
    state.form_sample = []
  },

  // FORM HEADER
  SET_HEADER: (state, payload) => {
    if (Array.isArray(payload)) {
      payload.map(obj => {
        state.form_header[obj.key] = obj.value;
      });
    } else {
      state.form_header[payload.key] = payload.value;
    }
  },

  // CONTACT
  SET_CONTACT: (state, payload) => {
    state.form_contact.push(payload);
  },
  SET_CONTACT_LINE: (state, payload) => {
    state.form_contact[payload.line][payload.key] = payload.value;
  },
  DELETE_CONTACT_LINE: (state, payload) => {
    state.form_contact.splice(payload, 1);
  },

  // CARD
  SET_CARD: (state, payload) => {
    state.form_card.push(payload);
  },
  SET_CARD_LINE: (state, payload) => {
    state.form_card[payload.line][payload.key] = payload.value; 
  },
  DELETE_CARD_LINE: (state, payload) => {
    state.form_card.splice(payload, 1);
  },

  // SAMPLE
  SET_SAMPLE: (state, payload) => {
    state.form_sample.push(payload);
  },
  SET_SAMPLE_LINE: (state, payload) => {
    state.form_sample[payload.line][payload.key] = payload.value;
  },
  DELETE_SAMPLE_LINE: (state, payload) => {
    state.form_sample.splice(payload, 1);
  },

  // GLOBAL
  SET_TTOP_GRAT: (state, payload) => {
    state.form_card.map( (object, index) => {
      state.form_card[index].ttop_grat = payload.value;
    });
  },
  SET_TTOP_ELECTRO: (state, payload) => {
    state.form_card.map( (object, index) => {
      state.form_card[index].telectro = payload.value;
    });
  },
  SET_TYPOLOGY: (state, payload) => {
   
    let nIndex = state.form_typology.findIndex(test => test['TMOTCLE'] === payload['TMOTCLE'] );

    if (nIndex === -1) {
      state.form_typology.push(payload);  
    } else {
      state.form_typology.splice(nIndex, 1);   
    }
  },

  // SPECIAL REQUEST
  SET_SPECIAL_REQUEST: (state, payload) => {
    state.form_special_request[payload.key] = payload.value;
  }
};